import { TAnyTask } from 'lib/common/contexts/ContactContext';

import { OUTBOUND_CAMPAIGN } from 'lib/common/constants/contactAttributes';

import getUserName from 'lib/common/utils/getUserName';

import getContactAttributes from '../getContactAttributes';

export function getTaskTitle(task: TAnyTask) {
  const outboundCampaignName = getContactAttributes({ task }, OUTBOUND_CAMPAIGN)[OUTBOUND_CAMPAIGN];

  // If Campaign Name is defined, use it as title for preview dialing tasks, otherwise fallback
  if (task.type === 'PREVIEW_DIALING' && outboundCampaignName) {
    return outboundCampaignName;
  }

  return task.profile?.firstName ? getUserName(task?.profile) : task?.connectionValue;
}
